/**
 * Both bounds or neither, and end strictly after start. Shared by the API
 * resolvers and the staff UI so rule and message can't drift. Returns the
 * problem message, or null for a valid (or fully absent) window.
 */
export function getDowntimeWindowErrorMessage(
  downtimeWindowStart: Date | null,
  downtimeWindowEnd: Date | null
): string | null {
  if ((downtimeWindowStart === null) !== (downtimeWindowEnd === null)) {
    return "Set both downtime window bounds or neither.";
  }
  if (downtimeWindowStart && downtimeWindowEnd && downtimeWindowEnd <= downtimeWindowStart) {
    return "Downtime window must end after it starts.";
  }
  return null;
}
